
const modules = require.context('assets/icons', true, /\.svg$/)

const ICONS = {}

modules.keys().forEach(path => {
  const key = path.replace('./', '').replace('.svg', '')
  ICONS[key] = modules(path)
})

const __default__ = {
  props: {
    asset: {
      type: String,
      required: false,
      default: undefined
    },
    icon: {
      type: String,
      required: false,
      default: undefined
    },
    external: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    size: {
      type: [Number, String],
      default: undefined
    },
    hoverable: {
      type: Boolean, 
      default: false
    },
    stroke: {
      type: String,
      default: undefined
    },
    hover: {
      type: Boolean,
      default: false
    },
    hoverColor: {
      type: String,
      default: 'var(--brand-900)'
    }
  },
  data() {
    return {
      svg_data: undefined
    }
  },
  computed: {
    c_width(){
      if (this.size) return this.size
      return this.width
    },
    c_height(){
      if (this.size) return this.size
      return this.height
    },
    is_fomantic() {
      return this.icon ? this.icon.indexOf('fm ') === 0 : false
    },
    fomantic_class() {
      return this.icon.replace('fm ', '')
    },
    href_full() {
      if (this.svg_data) return `data:image/svg+xml;utf8,${encodeURIComponent(this.svg_data)}`
      if (this.asset) return `/assets/${this.asset}.svg`
      if (this.icon) return `/assets/icons/${this.icon}.svg`
      throw new Error('Failed to form icon href')
    }
  },
  watch: {
    async icon(){
      this.updateIcon()
    }
  },
  async mounted() {
    this.updateIcon()
  },
  updated() {
    if (this.external || !this.svg_data) {
      return
    }

    const svgdiv = this.$refs.svgdiv
    if (!svgdiv.firstChild) {
      return
    }

    const attrs = [...svgdiv.attributes]
    attrs.forEach((attr) => {
      if (!['width', 'height'].includes(attr.name)) {
        svgdiv.firstChild.setAttribute(attr.name, attr.value)
      }
    })
  },
  methods: {
    async updateIcon(){
      this.svg_data = ICONS[this.icon]?.trim()
      if (this.svg_data || this.external) return

      try {
        const resp = await fetch(this.href_full)
        if (!resp.ok) {
          console.log(`Failed to get ${this.href_full}. Status code ${resp.status}`)
          return
        }
        this.svg_data = (await resp.text()).trim()
      }
      catch(err) {
        console.log(`Failed to fetch ${this.href_full}. ${err}`)
        return
      }
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "db11e7ae-stroke": (_ctx.stroke),
  "db11e7ae-hoverColor": (_ctx.hoverColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__